let location = {
  reLocationNet: {
    //上报位置坐标

    /***上报人员、摄像头、定位设备的位置数据
    **/
    url: '/scooper-trace/data/trace/reLocation',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    requestParam: {
      token: '',
      propType: '',
      //坐标位置所属类型 0-人员，1-摄像头，2-定位设备
      propKey: '',
      //属性关联如：人员ID、摄像头ID、定位设备ID
      posLocation: '',
      //gis点位坐标对象属性(longitude,latitude)
      recordTime: '',
      //定位时间,不传默认上报时间为定位时间
      posChange: '',
      //坐标位置改变标识0-未改变，1-改变
      posAltitude: '',
      //位置海拔高度（米）
      posSpeed: '',
      //移动速度（km/h）
      posDirectionHorizontal: '',
      //方位角（水平）
      posDirectionVertical: '',
      //仰角（垂直）
      posAttr: '',
      //坐标位置属性1：室内，0：室外
      propKeyIndoor: '',
      //室内关联属性，标识在哪个室内
      coordinateType: '',
      //使用的坐标系类型（谷歌坐标系gcj02、百度坐标系bd09、wgs84）
      locType: '',
      //定位方式161 室内，61室外
      radius: '' //定位精度

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        id: '',
        propType: '',
        propKey: "",
        posLocation: {
          longitude: '',
          latitude: ''
        }
      }
    }
  },
  listTraceByArgsNet: {
    //列表查询人员轨迹

    /***按时间查询轨迹列表
    **/
    url: '/scooper-trace/data/trace/listTraceByArgs',
    method: 'GET',
    requestParam: {
      token: '',
      propType: '',
      //坐标位置所属类型 0-人员，1-摄像头，2-定位设备
      propKey: '',
      //属性关联如：人员ID、摄像头ID、定位设备ID
      startTime: '',
      endTime: '',
      useExternal: '',
      //使用第三方纠偏数据
      decrease: '',
      //轨迹数据是否抽稀
      clusterDistance: '' //抽稀距离,单位米（m）

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: [{
        id: '',
        propType: '',
        propKey: '',
        posLocation: {
          longitude: '',
          latitude: ''
        },
        recordTime: '',
        //记录时间
        breakpoint: '',
        //是否为断点：0-否；1-是
        posAltitude: '',
        //位置海拔高度（米）
        posSpeed: '',
        //移动速度（km/h）
        posDirectionHorizontal: '',
        //方位角（水平）
        posDirectionVertical: '',
        //仰角（垂直）
        posAttr: '',
        //坐标位置属性：1：室内，0：室外
        propKeyIndoor: '',
        //室内关联属性，标识在哪个室内
        posChange: '',
        //坐标位置改变标识，0-未改变，1-改变
        updateTime: '',
        //本条记录最后更新时间
        radius: '' //定位精度

      }]
    }
  },
  listTraceByArgsPageNet: {
    //分页查询人员轨迹

    /***按时间分页查询轨迹
    **/
    url: '/scooper-trace/data/trace/listTraceByArgsPage',
    method: 'GET',
    requestParam: {
      token: '',
      propType: '',
      //坐标位置所属类型 0-人员，1-摄像头，2-定位设备
      propKey: '',
      //属性关联如：人员ID、摄像头ID、定位设备ID
      startTime: '',
      endTime: '',
      useExternal: '',
      //使用第三方纠偏数据
      decrease: '',
      //轨迹数据是否抽稀
      timespan: '',
      //指定跳过时间间隔,单位秒
      pageNumber: '',
      pageSize: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        total: '',
        list: [{
          id: '',
          propType: '',
          propKey: '',
          posLocation: {
            longitude: '',
            latitude: ''
          },
          recordTime: '',
          //记录时间
          breakpoint: '',
          //是否为断点：0-否；1-是
          posAltitude: '',
          //位置海拔高度（米）
          posSpeed: '',
          //移动速度（km/h）
          posDirectionHorizontal: '',
          //方位角（水平）
          posDirectionVertical: '',
          //仰角（垂直）
          posAttr: '',
          //坐标位置属性：1：室内，0：室外
          propKeyIndoor: '',
          //室内关联属性，标识在哪个室内
          posChange: '',
          //坐标位置改变标识，0-未改变，1-改变
          updateTime: '',
          //本条记录最后更新时间
          radius: '' //定位精度

        }]
      }
    }
  },
  listGisTrailNet: {
    //查询gis轨迹数据

    /***
    **/
    url: '/scooper-app-msg/gis/queryGisTrails',
    method: 'GET',
    requestParam: {
      startTime: '',
      endTime: '',
      timespan: '',
      memId: '',
      accId: '',
      token: '',
      pageNumber: 1,
      pageSize: 50
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        total: '',
        pageSize: '',
        pageNumber: '',
        list: [{
          altitude: 0,
          center: {
            longitude: 120.026576,
            latitude: 30.823369
          },
          childMapId: 0,
          corpId: 0,
          evtLevel: 0,
          extData: "",
          geoHash: "wtmr770xjumy",
          hasChild: false,
          id: 1,
          layerId: 1,
          layerLogicName: "person",
          mapId: 0,
          name: "单兵01",
          parentId: 0,
          permKey: "300000.000002.002",
          points: [{
            longitude: 0,
            latitude: 0
          }],
          posStatus: "offline",
          propKey: "6",
          rectMax: {
            longitude: 120.026576,
            latitude: 30.823369
          },
          rectMin: {
            longitude: 120.026576,
            latitude: 30.823369
          },
          speed: 0,
          type: "Point",
          updateTime: "2022-04-22 14:21:30"
        }]
      }
    }
  },
  listTypeLocationNet: {
    //按类型查询设备点位信息

    /***按类型查询，类型：1.移动点位：person， 2.固定点位：fixed, 3.视频监控：camera
    **/
    url: '/common-gis-web/data/gisquery/search',
    method: 'POST',
    requestParam: {
      mapId: '',
      //地图类型
      kw: '',
      //关键字
      layers: '' //设备类型 可选

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        total: '',
        pageSize: '',
        pageNumber: '',
        list: [{
          altitude: 0,
          center: {
            longitude: 120.026576,
            latitude: 30.823369
          },
          childMapId: 0,
          corpId: 0,
          evtLevel: 0,
          extData: "",
          geoHash: "wtmr770xjumy",
          hasChild: false,
          id: 1,
          layerId: 1,
          layerLogicName: "person",
          mapId: 0,
          name: "单兵01",
          parentId: 0,
          permKey: "300000.000002.002",
          points: [{
            longitude: 0,
            latitude: 0
          }],
          posStatus: "offline",
          propKey: "6",
          rectMax: {
            longitude: 120.026576,
            latitude: 30.823369
          },
          rectMin: {
            longitude: 120.026576,
            latitude: 30.823369
          },
          speed: 0,
          type: "Point",
          updateTime: "2022-04-22 14:21:30"
        }]
      }
    }
  },

  /**
   * MQTT订阅
   */
  moveMQNet: function (propType, propKey) {
    /**
     * {propType}为类型、{propKey}为坐标关联属性，如人员id
     */
    return {
      //坐标位置变动通知
      topic: `/scooper-trace/notify/move/${propType}/${propKey}`,
      responseParam: {
        id: 0,
        //轨迹服务推送队列id
        type: 'notify',
        //消息类别
        source: 'scooper-trace',
        //消息来源
        data: {
          //通知的具体消息
          id: '',
          propType: '',
          propKey: '',
          posLocation: {
            longitude: '',
            latitude: ''
          },
          posAltitude: '',
          //位置海拔高度（米）
          posSpeed: '',
          //移动速度（km/h）
          posDirectionHorizontal: '',
          //方位角（水平）
          posDirectionVertical: '',
          //仰角（垂直）
          posAttr: '',
          //坐标位置属性：1：室内，0：室外
          propKeyIndoor: '',
          //室内关联属性，标识在哪个室内
          posChange: '',
          //坐标位置改变标识，0-未改变，1-改变
          updateTime: '',
          //本条记录最后更新时间
          radius: '' //定位精度

        }
      }
    };
  },

  /**
   * HTTP推送
   */
  gisHttpNet: function () {
    return {
      //坐标位置变动通知HTTP推送通知
      url: '/notify/orgmember/gis',
      method: 'POST',
      requestParam: {
        id: '',
        //属性关联id, 如成员id等对比上报位置接口的propKey属性
        gis: '' //人员gis坐标，经纬度之间用","隔开(经度放前面)

      },
      responseParam: {
        code: '',
        //返回结果状态码
        message: '',
        systemTime: '',
        //yyyy-MM-dd HH:mm:ss
        data: {}
      }
    };
  }
};
export default location;